/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ecash_chain_about = () => `eCash is a blockchain project led by Bitcoin ABC, aiming to enhance L1 scalability, security, transaction speed, and cost-effectiveness. It integrates the Avalanche consensus protocol with its base PoW consensus, making it effectively a hybrid consensus network that is secured against 51% attacks and extensible via subnets and hard-fork free upgrades. These improvements address scalability concerns, enable rapid transaction finality, interoperability, and guarantee subcent fees. Despite these improvements, eCash remains committed to maintaining the decentralization principles of the original Bitcoin protocol. By prioritizing scalability and extensibility, eCash seeks to realize the vision of Bitcoin as a practical and accessible peer-to-peer electronic cash system.`
